import {
  TextField,
  InputAdornment,
  IconButton,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import moment from "moment";
import { useEffect, useState } from "react";
import BlockUi from "react-block-ui";
import { Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { AiOutlineCloseCircle, AiOutlineInfoCircle } from "react-icons/ai";
import { FaFileAlt } from "react-icons/fa";

import { HiOutlineShare } from "react-icons/hi";
import { IoIosAddCircleOutline } from "react-icons/io";
import { IoShareSocialOutline } from "react-icons/io5";
import { PiNewspaperClippingThin } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import MyYuukke from "../../../api/MyYuukke";
import SocialShare from "../../../components/SocialShare";
import { API_URL, BASE_URL } from "../../../config/app-config";
import { getUserService, getUserResourceList } from "../../../redux/actions/calendarAction";
import { shareUrl } from "../../../utils";
import { dBody, serviceIcons, themesPallates } from "../../../components/Utils";
import ServiceProfileWizardCard from "./ServiceAiAssistant";
import * as APPCONFIG from "../../../config/app-config.js";
import AdvertiseServiceModal from "./AdvertiseServiceModal.jsx";
import { withRouter } from "react-router";
import ServiceCreateForm from "./ServiceCreateForm.jsx";
import ResourceCreateForm from "./ResourceCreateForm.jsx";
import { FiCopy, FiDownload } from "react-icons/fi";
import ApprovalPendingModal from "./ApprovalPendingModal.jsx";

import { OPENROUTER_CHAT_URL } from "../../../utils/getOpenRouterChatUrl";
import "./Services.css";

const EXT_TO_DOC_TYPE = {
  pdf: "PDF", xlsx: "EXCEL", xls: "EXCEL", csv: "EXCEL", docx: "AGREEMENT", odt: "ODT",
};

const ALLOWED_RESOURCE_EXTENSIONS = Object.keys(EXT_TO_DOC_TYPE);
const ALLOWED_RESOURCE_ACCEPT = ALLOWED_RESOURCE_EXTENSIONS.map((e) => `.${e}`).join(",");

const getFileExtension = (file) => (file?.name || "").split(".").pop()?.toLowerCase() || "";
const docTypeFromFile = (file) => EXT_TO_DOC_TYPE[getFileExtension(file)] || null;
const isAllowedResourceFile = (file) => ALLOWED_RESOURCE_EXTENSIONS.includes(getFileExtension(file));

const filterAllowedResourceFiles = (files) => {
  const incoming = Array.from(files || []);
  const accepted = [];
  const rejected = [];

  incoming.forEach((file) => {
    if (isAllowedResourceFile(file)) accepted.push(file);
    else rejected.push(file.name);
  });

  if (rejected.length > 0) {
    toast.warning(`Only PDF, Excel, Word, and ODT files are allowed. Rejected: ${rejected.join(", ")}`);
  }
  return accepted;
};

const Services = (props) => {
  const appointmentTypes = [
    { value: "one_to_one_consultation", label: "One-to-One Consultation", prize: 0, select: false },
    { value: "primary_discussion", label: "Primary Discussion", prize: 0, select: false },
    { value: "group_package", label: "Group Package", prize: 0, select: false },
    { value: "others", label: "Others", prize: 0, select: false },
  ];
 
  const activeOptions = [
    { value: 15,  label: "15 Minute Meeting" }, { value: 30,  label: "30 Minute Meeting" },
    { value: 45,  label: "45 Minute Meeting" }, { value: 60,  label: "60 Minute Meeting" },
    { value: 240, label: "Half Day Session" }, { value: 480, label: "Full Day Session" },
  ];

  const categories = [
    { value: 0, label: "Consulting" }, { value: 1, label: "Education & Training" },
    { value: 2, label: "Personal Well-being" }, { value: 3, label: "Marketing & Growth" },
    { value: 4, label: "Lifestyle" }, { value: 5, label: "Financial & Legal" },
    { value: 6, label: "Academic Consulting" }, { value: 7, label: "Business Consulting" },
    { value: 8, label: "Career Coaching" }, { value: 9, label: "Coaching & Mentoring" },
    { value: 10, label: "Counseling and Therapy" }, { value: 11, label: "Cybersecurity" },
    { value: 12, label: "Digital Marketing" }, { value: 13, label: "Fashion & Style" },
    { value: 14, label: "Finance" }, { value: 15, label: "Health & Wellness" },
    { value: 16, label: "Home & Living" }, { value: 17, label: "Investment" },
    { value: 18, label: "K12 and Higher Education Tuition" }, { value: 19, label: "Leadership and Management" },
    { value: 20, label: "Legal Support" }, { value: 21, label: "Mental Health" },
    { value: 22, label: "Personal Development" }, { value: 23, label: "PR Consulting" },
    { value: 24, label: "Technology" }, { value: 25, label: "Travel Advisor" },
  ];

  const packagePeriod = [
    { value: "WEEKLY", label: "Weekly" }, { value: "MONTHLY", label: "Monthly" }, { value: "YEARLY", label: "Yearly" },
  ];

  const plainWeekDays = [
    { value: "MON", label: "Monday" }, { value: "TUE", label: "Tuesday" }, { value: "WED", label: "Wednesday" },
    { value: "THU", label: "Thursday" }, { value: "FRI", label: "Friday" }, { value: "SAT", label: "Saturday" },
    { value: "SUN", label: "Sunday" },
  ];

  const { t } = props;
  const { userServiceList, userSlots, serviceDashboard, resourceList } = useSelector((s) => s.event);
  const dispatch = useDispatch();

  const contactAdminEnabled = serviceDashboard?.contactAdminEnabled;

  const [state, setState] = useState({
    serviceList: [], activeType: null, activeMenu: 0, title: "", prize: 0,
    activeMinutes: { value: 15, label: "15 Minute Meeting" }, userServiceList: [],
    userResourceList: [], serviceWholeList: [], serviceId: null, allMenu: true, menuType: "",
    assessmentListUpdated: [], assessmentData: [], removeId: [], subMenu: "",
    shareCalendar: false, assessmentNeed: false, assessmentAnswer: [], shareUrl: "", qrUrl: "",
    description: "", pagePreview: false, isEdit: false, previewUrl: "",
    serviceLogo: null, serviceFeatures: [], active: true, feature: "",
    iconId: 0, cat: { value: 0, label: "Consulting" }, isDeleted: false,
    packageDays: [], isRecurring: false, timeSlots: [], packagePeriod: "CUSTOM",
    listingType: "service", resourceFiles: [], existingResourceFiles: [],
  });

  const [activeTab, setActiveTab] = useState("service");
  const [showTypeSelection, setShowTypeSelection] = useState(false);
  const [showAiAssistant, setShowAiAssistant] = useState(false);
  const [autoTriggerActive, setAutoTriggerActive] = useState(false);
  const [assistantLoading, setAssistantLoading] = useState(false);
  const [assistantQuestion, setAssistantQuestion] = useState("");
  const [assistantQuestionsAsked, setAssistantQuestionsAsked] = useState(0);
  const [assistantInput, setAssistantInput] = useState("");
  const [assistantAnswers, setAssistantAnswers] = useState(null);
  const [assistantIsSummary, setAssistantIsSummary] = useState(false);
  const [assistantSummaryText, setAssistantSummaryText] = useState("");
  const [aiLimit, setAiLimit] = useState(null);
  const [showAiHint, setShowAiHint] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [chosenFilter, setChosenFilter] = useState({ value: null, label: "All Status" });
  const [showApprovalModal, setShowApprovalModal] = useState(false);

  const updateState = (name, value) => setState((p) => ({ ...p, [name]: value }));
  
  const updateFeature = (value, ind) => {
    let list = [...state.serviceFeatures];
    if (value) list[ind] = value;
    else list = list.filter((_, i) => i !== ind);
    setState((p) => ({ ...p, serviceFeatures: list }));
  };

  const addResourceFiles = (fileList) => {
    const accepted = filterAllowedResourceFiles(fileList);
    if (accepted.length === 0) return;
    if (accepted.length > 1) toast.warning("Only one file is allowed per resource. Using the first file selected.");
    setState((p) => ({ ...p, resourceFiles: [accepted[0]] }));
  };

  const removeResourceFile = (index) => {
    setState((p) => ({ ...p, resourceFiles: p.resourceFiles.filter((_, i) => i !== index) }));
  };

  const removeExistingResourceFile = (index) => {
    setState((p) => ({ ...p, existingResourceFiles: p.existingResourceFiles.filter((_, i) => i !== index) }));
  };

  const parseSafe = (val, fb = []) => {
    try {
      let p = typeof val === "string" ? JSON.parse(val) : val;
      if (typeof p === "string") p = JSON.parse(p);
      return p;
    } catch {
      return fb;
    }
  };

  const handleAssistantClose = () => {
    setShowAiAssistant(false); setAssistantLoading(false); setAssistantQuestion("");
    setAssistantQuestionsAsked(0); setAssistantInput(""); setAssistantAnswers(null);
    setAssistantIsSummary(false); setAssistantSummaryText("");
  };

  const handleAssistantNext = (answersObj) => setAssistantAnswers(answersObj);

  useEffect(() => {
    const run = async () => {
      if (!showAiAssistant || !state.title || !assistantAnswers) return;
      setAssistantLoading(true); setAssistantIsSummary(false);
      try {
        const audience = assistantAnswers?.audience || "";
        const outcome  = assistantAnswers?.outcome  || "";
        const isGroupPkg = state.activeType?.value === "group_package";
        let groupContext = "";
        
        if (isGroupPkg) {
          const days = (state.packageDays || []).join(", ");
          const recurring = state.isRecurring ? "Yes" : "No";
          const period = state.packagePeriod && state.packagePeriod !== "CUSTOM" ? state.packagePeriod : "";
          const duration = state.activeMinutes?.value ? `${state.activeMinutes.value} minutes` : "";
          const groupSize = state.groupSize ? `${state.groupSize} participants` : "";
          const timeSlot = (state.timeSlots || [])[0] ? `${state.timeSlots[0].from} – ${state.timeSlots[0].to}` : "";

          groupContext = `
            Package Type: Group Package
            Available Days: ${days || "Not specified"}
            Recurring: ${recurring}${period ? ` (${period})` : ""}
            Session Duration: ${duration || "Not specified"}
            Group Size: ${groupSize || "Not specified"}
            Time Slot: ${timeSlot || "Not specified"}`;
        }

        const prompt = `You are an expert service profile writer and SEO copywriter.
Service Name: "${state.title}"
Service Type: ${state.activeType?.label || "Consultation"}${groupContext}
${audience ? `Target Audience: ${audience}` : ""}
${outcome  ? `Key Outcome for Clients: ${outcome}` : ""}

Write optimised content. Output EXACTLY in this format (no extra text, no markdown):
DESCRIPTION: [2-3 sentences. Professional, benefit-focused, SEO-friendly. Mention the service name naturally. Max 280 chars.]
FEATURES: [feature1] | [feature2] | [feature3] | [feature4] | [feature5]`;

        const res = await fetch(OPENROUTER_CHAT_URL, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ prompt }),
        });
        
        if (!res.ok) throw new Error(`AI request failed: ${res.status}`);

        const json = await res.json();
        const text = (json?.data?.reply || json?.data || json?.message || "").trim();

        if (!text) throw new Error("Empty response from AI");

        const descMatch = text.match(/DESCRIPTION:\s*(.+?)(?=FEATURES:|$)/s);
        const featMatch = text.match(/FEATURES:\s*(.+)/s);

        const description = descMatch?.[1]?.trim() || "";
        const features = featMatch?.[1]?.split("|").map(f => f.trim()).filter(Boolean).slice(0, 5) || [];

        if (description) updateState("description", description);
        if (features.length > 0) {
          const filled = [...features];
          while (filled.length < 5) filled.push("");
          setState((p) => ({ ...p, serviceFeatures: filled.slice(0, 5) }));
        }

        setAssistantSummaryText(text);
        setAssistantIsSummary(true);
        try { await MyYuukke.updateAiLimit(); } catch (_) {}
        toast.success("AI content applied! Review and edit as needed.");
      } catch (err) {
        toast.error("Unable to generate content. Please try again.");
        setShowAiAssistant(false);
      }
      setAssistantLoading(false);
    };

    if (showAiAssistant && assistantAnswers) run();
  }, [showAiAssistant, assistantAnswers]);

  useEffect(() => {
    MyYuukke.getAiLimit().then((r) => setAiLimit(r?.data?.status === 1 ? r.data.data : 0)).catch(() => setAiLimit(0));
  }, []);

  useEffect(() => { if (userServiceList) updateState("userServiceList", userServiceList); }, [userServiceList]);
  useEffect(() => { if (resourceList) updateState("userResourceList", resourceList); }, [resourceList]);
  useEffect(() => { if (props.neededTypeRedirect) { updateState("menuType", props.neededTypeRedirect); props.clearNeededType(); } }, [props.neededTypeRedirect]);
  useEffect(() => { dispatch(getUserService()); }, [dispatch]);
  useEffect(() => { if (userSlots?.preference?.id) dispatch(getUserResourceList(userSlots.preference.id)); }, [dispatch, userSlots?.preference?.id]);

  const makeChanges = (type, item) => {
    if (type !== "edit" && type !== "update" && type !== "share") return;

    if (item.listingType === "resource") {
      const newObj = {
        ...state, isEdit: true, serviceId: item.id, menuType: type === "edit" ? "update-resource" : "", listingType: "resource",
        title: item.serviceName, prize: item.amount, description: item.description ?? "", active: item.active,
        serviceLogo: item.serviceImagePath ?? null, cat: categories.find((d) => d.value === (item.category ?? 0)) ?? { value: 0, label: "Consulting" },
        iconId: item.iconId ?? 0,
        existingResourceFiles: (item.resourceFiles ?? (item.resourceFileNames || []).map((fileName) => ({ fileName, docType: null }))).slice(0, 1),
        resourceFiles: [],
      };
      setState(newObj); setSelectedService(newObj);
      if (type === "share") { setShareModalOpen(true); return; }
      if (type === "update") createResource(null, newObj, false);
      return;
    }

    MyYuukke.getSingleService({ id: item.id }).then((response) => {
        if (response?.data?.status !== 1) { toast.warn("Please try again"); return; }
        const result = response.data.data;
        const matchedType = appointmentTypes.find((d) => d.value === result.data.appointmentValue) ?? appointmentTypes[0];

        const newObj = {
          ...state, isEdit: true, serviceId: item.id, menuType: type === "edit" ? "update-service" : "", listingType: "service",
          title: result.data.serviceName, prize: result.data.amount, description: result.data?.description ?? "", active: item.active,
          serviceLogo: result.data.img, activeMinutes: { value: result.data.duration, label: `${result.data.duration} Minute Meeting` },
          activeType: matchedType, cat: categories.find((d) => d.value === (result.data?.category ?? 0)) ?? { value: 0, label: "Consulting" }, iconId: result.data.iconId ?? 0,
          serviceFeatures: (() => { const r = result?.data?.features ? result.data.features.split(",") : []; while (r.length < 5) r.push(""); return r.slice(0, 5); })(),
          assessmentData: result.questions ?? [], assessmentNeed: result.data.assessmentNeed ?? false, isRecurring: result.data.recurring ?? false,
          packagePeriod: result.data.packagePeriod ?? "CUSTOM", packageDays: parseSafe(result.data.packageDays, []), timeSlots: parseSafe(result.data.timeSlots, []),
          groupSize: result.data.groupSize ?? "", resourceFiles: [], existingResourceFiles: [],
        };
        setState(newObj); setSelectedService(newObj);
        if (type === "share") { setShareModalOpen(true); return; }
        if (type === "update") createService(null, newObj, false);
      }).catch(() => toast.error("Something went wrong"));
  };

  const finishSave = (response, st, label) => {
    toast.success(`${label} ${st.isEdit ? "updated" : "created"} successfully`);
    const isResource = st.listingType === "resource";
    const currentList = isResource ? (resourceList || []) : (userServiceList || []);

    const savedData = response?.data?.data;
    let list = [];

    // Optimistically update the list on the frontend even if backend response is empty
    if (st.serviceId) {
      list = currentList.map((item) => {
        if (item.id === st.serviceId) {
          return {
            ...item,
            ...(savedData || {}),
            active: st.active,
            isActive: st.active, // Ensure both property names reflect the toggled state locally
          };
        }
        return item;
      });
    }
    
    let updatedList = st.serviceId ? list : (savedData ? [savedData, ...currentList] : currentList);
    updatedList = updatedList.filter(Boolean); // Safeguard against null/undefined records

    setState((p) => ({
      ...p, title: "", prize: "", serviceFeatures: ["", "", "", "", ""], serviceLogo: null, description: "", cat: "", iconId: "", activeType: null,
      activeMinutes: null, timeSlots: [], packageDays: [], groupSize: "", packagePeriod: "", isRecurring: false, isActive: true, isDeleted: false,
      assessmentData: [], assessmentNeed: false, loader: false, isEdit: false, menuType: "", listingType: "service", resourceFiles: [], existingResourceFiles: [],
      ...(isResource ? { userResourceList: updatedList } : { userServiceList: updatedList }), allMenu: true,
    }));

    // If the API payload was empty, we MUST force a background refetch from the API to guarantee sync.
    if (!savedData) {
       if (isResource) dispatch(getUserResourceList(userSlots?.preference?.id));
       else dispatch(getUserService());
    } else {
       if (isResource) dispatch(getUserResourceList(userSlots?.preference?.id, "update", updatedList));
       else dispatch(getUserService("update", updatedList));
    }

    setAssistantIsSummary(false); setAssistantAnswers(null); props.onBack(5);
  };

  const createService = (e, st, isCreate) => {
    e?.preventDefault();
    if (!st.title?.trim() || st.prize === "" || st.prize === null || isNaN(st.prize) || Number(st.prize) < 0 || !st.description?.trim()) return toast.warning("Please fill required fields correctly");
    const filledFeatures = (st.serviceFeatures || []).filter((f) => f && f.trim());
    if (filledFeatures.length < 5) return toast.warning(`Please add 5 service features`);
    
    const fd = new FormData();
    fd.append("listingType", "service"); fd.append("amount", st.prize); fd.append("calendarId", userSlots?.preference?.id || ""); fd.append("serviceName", st.title);
    if (st.serviceLogo instanceof File) fd.append("serviceImage", st.serviceLogo);
    fd.append("description", st.description); fd.append("packageName", st.serviceFeatures.join(",")); fd.append("isActive", st.active);
    fd.append("isDeleted", st.isDeleted); fd.append("category", st.cat?.value || ""); fd.append("iconId", st.iconId || "");
    fd.append("meetingActiveDuration", st.activeMinutes?.value || 0); fd.append("appointmentType", st.activeType?.label || "");
    fd.append("appointmentTypeValue", st.activeType?.value || ""); fd.append("assessmentNeed", st.assessmentNeed);
    fd.append("packagePeriod", st.packagePeriod || ""); fd.append("recurringState", st.isRecurring); fd.append("timeSlots", JSON.stringify(st.timeSlots || []));
    fd.append("packageDays", JSON.stringify(st.packageDays || [])); fd.append("groupSize", st.groupSize || 0);

    if (st.assessmentData.length > 0) {
      const data = st.assessmentData.map((item) => ({ question: item.question, answer: item.answerType === "select" ? item.answerIds : item.textTypeAnswer, answerType: item.answerType, ...(item.questionId ? { questionId: item.questionId } : {}), }));
      fd.append("selfAssessmentData", JSON.stringify({ questions: data }));
    }
    if (st.serviceId !== null) fd.append("id", st.serviceId);

    MyYuukke.saveService(fd, { header: { "content-type": "multipart/form-data" } }).then((response) => finishSave(response, st, "Service")).catch(() => { toast.error("Something went wrong"); setState((p) => ({ ...p, loader: false, menuType: "" })); });
  };

  const createResource = (e, st, isCreate) => {
    e?.preventDefault();
    if (!st.title?.trim() || st.prize === "" || st.prize === null || isNaN(st.prize) || Number(st.prize) < 0 || !st.description?.trim()) return toast.warning("Please fill required fields correctly");

    const fd = new FormData();
    fd.append("listingType", "resource"); fd.append("amount", st.prize); fd.append("calendarId", userSlots?.preference?.id || ""); fd.append("serviceName", st.title);
    if (st.serviceLogo instanceof File) fd.append("serviceImage", st.serviceLogo);
    fd.append("description", st.description); fd.append("isActive", st.active); fd.append("isDeleted", st.isDeleted);
    fd.append("category", st.cat?.value || ""); fd.append("iconId", st.iconId || "");

    if (Array.isArray(st.resourceFiles)) {
      st.resourceFiles.forEach((file) => { if (file instanceof File) fd.append("resourceFile", file); });
      st.resourceFiles.forEach((file) => { if (file instanceof File) fd.append("resourceFileDocType", docTypeFromFile(file)); });
    }
    if (Array.isArray(st.existingResourceFiles)) fd.append("existingResourceFiles", JSON.stringify(st.existingResourceFiles));
    if (st.serviceId !== null) fd.append("id", st.serviceId);

    MyYuukke.saveResource(fd, { header: { "content-type": "multipart/form-data" } }).then((response) => finishSave(response, st, "Resource")).catch(() => { toast.error("Something went wrong"); setState((p) => ({ ...p, loader: false, menuType: "" })); });
  };

  const newService = (type = "service") => {
    setAssistantIsSummary(false); setAssistantAnswers(null); setShowAiAssistant(false); setShowTypeSelection(false);
    setState((p) => ({ ...p, menuType: type === "resource" ? "new-resource" : "new-service", serviceId: null, isEdit: false, title: "", description: "", prize: 0, activeType: appointmentTypes[0], activeMinutes: { value: 15, label: "15 Minute Meeting" }, cat: { value: 0, label: "Consulting" }, iconId: 0, active: true, isDeleted: false, serviceLogo: null, serviceFeatures: ["", "", "", "", ""], feature: "", assessmentListUpdated: [], assessmentData: [], assessmentNeed: false, isRecurring: false, packagePeriod: "CUSTOM", packageDays: [], timeSlots: [], groupSize: "", removeId: [], subMenu: "", listingType: type, resourceFiles: [], existingResourceFiles: [], }));
    if (type === "service" && aiLimit !== null && aiLimit > 0) setShowAiHint(true);
  };

  const removedQuestionId = (data) => updateState("removeId", [...state.removeId, data]);

  const calendarShare = (status = false, id) => {
    if (!props?.userPrefDetails?.accountNumber) return Swal.fire({ icon: "warning", title: "Please Fill Your Account Details !", text: "We need your account details to process the credit of the service fee to your account.", showConfirmButton: true, showCancelButton: true, }).then(() => props.onBack(6));
    if (!contactAdminEnabled || userSlots?.preference?.approvalStatus !== "approved") { setShowApprovalModal(true); return; }
    setState((p) => ({ ...p, shareUrl: !id ? shareUrl(userSlots?.preference.id + "&id") : shareUrl(userSlots?.preference.id + "&id&" + id), shareCalendar: status, qrUrl: encodeURIComponent(`${BASE_URL}yuukke-service/${userSlots?.preference.slug}`), }));
  };

  const filterList = (keytxt, isSearch) => {
    const source = activeTab === "resource" ? (resourceList || []) : (userServiceList || []);
    const key = activeTab === "resource" ? "userResourceList" : "userServiceList";
    if (keytxt === null || keytxt === "") return updateState(key, source);
    updateState(key, source.filter((item) => isSearch ? item.serviceName?.toLocaleLowerCase().includes(keytxt) : item.active === keytxt));
  };

  const switchTab = (tab) => {
    if (tab === activeTab) return; setActiveTab(tab); setSearchText(""); setChosenFilter({ value: null, label: "All Status" });
    updateState(tab === "resource" ? "userResourceList" : "userServiceList", (tab === "resource" ? resourceList : userServiceList) || []);
  };

  const filteredAppointmentTypes = (() => {
    if (state.isEdit) return state.activeType?.value === "group_package" ? appointmentTypes.filter((t) => t.value === "group_package") : appointmentTypes.filter((t) => t.value !== "group_package");
    return appointmentTypes;
  })();

  const isServiceFormOpen  = state.menuType === "new-service"  || state.menuType === "update-service";
  const isResourceFormOpen = state.menuType === "new-resource" || state.menuType === "update-resource";

  const activeList = Array.isArray(activeTab === "resource" ? state.userResourceList : state.userServiceList) ? (activeTab === "resource" ? state.userResourceList : state.userServiceList) : [];

  const searchSourceList = activeTab === "resource" ? (resourceList || []) : (userServiceList || []);

  const renderServiceCard = (item, ind) => {
    const sessionsCount = item.sessionsCount ?? item.packageDays?.length ?? 0;
    return (
      <article key={ind} className="svc-list-row" role="listitem">
        <div className="svc-row-main">
          <div className="svc-row-content">
            <div className="svc-row-radio-mock" aria-hidden="true"></div>
            <div className="svc-row-text">
              <h3 className="svc-name">{item.serviceName}</h3>
              <p className="svc-desc">{item.description || "No description added yet"}</p>
            </div>
          </div>
          
          <div className="svc-row-details">
            <div className="svc-row-stats">
              <span className="svc-price">₹{Number(item.amount).toLocaleString()}</span>
              <span className="svc-duration">{sessionsCount > 1 ? `${sessionsCount} sessions · ${item.duration} mins` : `${item.duration} mins`}</span>
            </div>
            
            <div className="svc-row-status">
              <span className={`svc-status-pill ${item.active ? "active" : "draft"}`}>
                {item.active ? "Published" : "Draft"}
              </span>
            </div>
            
            <div className="svc-row-actions">
              <button type="button" className={`svc-toggle-switch ${item.active ? "is-active" : "is-inactive"}`} onClick={() => makeChanges("update", { ...item, listingType: "service", active: !item.active })} role="switch" aria-checked={item.active} aria-label={`Turn ${item.serviceName} ${item.active ? "off" : "on"}`} title="Toggle Active Status">
                <span className="svc-toggle-knob" />
              </button>
              <button className="svc-action-btn" onClick={() => makeChanges("edit", { ...item, listingType: "service" })} aria-label="Edit">
                Edit service
              </button>
              <button className="svc-action-icon" onClick={() => makeChanges("share", { ...item, listingType: "service" })} aria-label="Share">
                <HiOutlineShare size={18} />
              </button>
            </div>
          </div>
        </div>
      </article>
    );
  };

  const renderResourceCard = (item, ind) => {
    const files = item.resourceFileNames || (item.resourceFiles || []).map((f) => f.fileName) || [];
    const isFree = Number(item.amount) === 0;
    const currentActive = item.isActive ?? item.active;

    return (
      <article key={ind} className="svc-list-row" role="listitem">
        <div className="svc-row-main">
          <div className="svc-row-content">
            <div className="svc-row-radio-mock" aria-hidden="true"></div>
            <div className="svc-row-text">
              <h3 className="svc-name">{item.serviceName}</h3>
              <p className="svc-desc">{item.description || "No description added yet"}</p>
              {files.length > 0 && (
                <div className="svc-resource-meta">
                  <FaFileAlt size={12} color="var(--svc-text-muted)" />
                  <span>{files.length} file{files.length !== 1 ? "s" : ""}</span>
                </div>
              )}
            </div>
          </div>
          
          <div className="svc-row-details">
            <div className="svc-row-stats">
              <span className={`svc-price ${isFree ? "svc-price--free" : ""}`}>
                {isFree ? "Free" : `₹${Number(item.amount).toLocaleString()}`}
              </span>
              <span className="svc-duration">{item.downloadsCount ?? 0} downloads</span>
            </div>
            
            <div className="svc-row-status">
              <span className={`svc-status-pill ${currentActive ? "active" : "draft"}`}>
                {currentActive ? "Published" : "Draft"}
              </span>
            </div>
            
            <div className="svc-row-actions">
              <button type="button" className={`svc-toggle-switch ${currentActive ? "is-active" : "is-inactive"}`} onClick={() => makeChanges("update", { ...item, listingType: "resource", active: !currentActive, isActive: !currentActive })} role="switch" aria-checked={currentActive} title="Toggle Active Status">
                <span className="svc-toggle-knob" />
              </button>
              <button className="svc-action-btn" onClick={() => makeChanges("edit", { ...item, listingType: "resource" })}>
                Edit resource
              </button>
              <button className="svc-action-icon" onClick={() => makeChanges("share", { ...item, listingType: "resource" })}>
                <HiOutlineShare size={18} />
              </button>
            </div>
          </div>
        </div>
      </article>
    );
  };

  return (
    <BlockUi tag="div" message="Loading, please wait" style={{ minHeight: 134, width: "100%" }} className="wallLoadingPage" blocking={state.loader}>
      <main className="svc-page" aria-label="Services Dashboard">
        
        {/* ── Dashboard Header Area ── */}
        <header className="svc-dashboard-header">
          {state.menuType === "" ? (
            <div className="svc-header-container">
              <div className="svc-header-titles">
                <span className="svc-header-breadcrumb">OFFER & PUBLICATION</span>
                <h1 className="svc-page-title">{activeTab === "resource" ? "Resources" : "Services"}</h1>
                <p className="svc-page-sub">Define what you offer; keep public-page presentation in Pages.</p>
              </div>
              
              <div className="svc-header-actions-group">
                <button className="svc-btn-secondary" aria-label="Import">
                  Import {activeTab === "resource" ? "resource" : "service"}
                </button>
                <button className="svc-btn-primary" onClick={() => activeTab === "resource" ? newService("resource") : setShowTypeSelection(true)}>
                  Add {activeTab === "resource" ? "resource" : "service"}
                </button>
              </div>
            </div>
          ) : (
            <div className="svc-header-container">
              <h2 className="svc-page-title">{t("Services")}</h2>
            </div>
          )}
        </header>

        {/* ── Info Banner (Wireframe detail) ── */}
        {state.menuType === "" && (
          <div className="svc-info-banner">
             <AiOutlineInfoCircle className="svc-info-icon" size={20} />
             <div className="svc-info-text">
               <strong>Services and Pages have different jobs</strong>
               <p>Services owns the offer. Pages decides how approved offer details are presented and published.</p>
             </div>
          </div>
        )}

        {/* ── Tabs & Search Utility ── */}
        {state.menuType === "" && (
          <div className="svc-utilities-row">
            <div role="tablist" className="svc-tabs">
              {[
                { key: "service", label: "Services", count: (userServiceList || []).length },
                { key: "resource", label: "Resources", count: (resourceList || []).length },
              ].map((tab) => (
                <button key={tab.key} role="tab" aria-selected={activeTab === tab.key} onClick={() => switchTab(tab.key)} className={`svc-tab${activeTab === tab.key ? " svc-tab--active" : ""}`}>
                  {tab.label}
                  <span className="svc-tab-count">{tab.count}</span>
                </button>
              ))}
            </div>

            <div className="svc-search-filters">
                <TextField
                  variant="outlined"
                  placeholder={`Search...`}
                  value={searchText}
                  onChange={(e) => { setSearchText(e.target.value); filterList(e.target.value?.toLocaleLowerCase() || null, true); }}
                  InputProps={{
                    style: { height: 36, fontSize: "0.85rem", background: "#fff" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <circle cx="11" cy="11" r="8" /><path d="m21 21-4.3-4.3" />
                        </svg>
                      </InputAdornment>
                    ),
                    endAdornment: searchText && (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => { setSearchText(""); filterList(null, true); }}><AiOutlineCloseCircle /></IconButton>
                      </InputAdornment>
                    ),
                  }}
                  disabled={!searchSourceList.length}
                />
            </div>
          </div>
        )}

        {/* ── Main Content Area ── */}
        <section className="svc-content-section">
          {isServiceFormOpen ? (
            <ServiceCreateForm
              state={state} updateState={updateState} updateFeature={updateFeature} createService={createService} removedQuestionId={removedQuestionId}
              filteredAppointmentTypes={filteredAppointmentTypes} activeOptions={activeOptions} categories={categories} packagePeriod={packagePeriod} plainWeekDays={plainWeekDays}
              serviceIcons={serviceIcons} dBody={dBody} t={t} aiLimit={aiLimit} autoTriggerActive={autoTriggerActive} setAutoTriggerActive={setAutoTriggerActive}
              setShowAiAssistant={setShowAiAssistant} aiApplied={assistantIsSummary} dropFlowStyle={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
            />
          ) : isResourceFormOpen ? (
            <ResourceCreateForm
              state={state} updateState={updateState} createResource={createResource} t={t} addResourceFiles={addResourceFiles} removeResourceFile={removeResourceFile}
              removeExistingResourceFile={removeExistingResourceFile} allowedResourceAccept={ALLOWED_RESOURCE_ACCEPT} allowedResourceExtensions={ALLOWED_RESOURCE_EXTENSIONS} maxResourceFiles={1}
            />
          ) : (
            <div className="svc-catalogue-container">
              <div className="svc-catalogue-header">
                <h3>Your {activeTab === "resource" ? "resource" : "service"} catalogue</h3>
                <span className="svc-catalogue-action">Reorder</span>
              </div>
              <div className="svc-catalogue-list" role="list">
                {activeList.length > 0 ? (
                  activeList.map((item, ind) => {
                    if (!item) return null; // Safe guard against undefined items
                    return activeTab === "resource" ? renderResourceCard(item, ind) : renderServiceCard(item, ind)
                  })
                ) : (
                  <div className="svc-empty">
                    <PiNewspaperClippingThin size={60} color="var(--svc-border)" aria-hidden="true" />
                    <p>No {activeTab === "resource" ? "resources" : "services"} found. Add your first one to get started.</p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* ── MODALS ── */}
          <Dialog
            open={showTypeSelection}
            onClose={() => setShowTypeSelection(false)}
            maxWidth="sm"
            fullWidth
            PaperProps={{ style: { borderRadius: "12px", padding: "1rem", maxHeight: "85vh", overflowY: "auto" } }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
              <h3 style={{ margin: 0, fontWeight: 700, fontFamily: "'DM Sans', sans-serif" }}>What would you like to add?</h3>
              <IconButton onClick={() => setShowTypeSelection(false)}><AiOutlineCloseCircle /></IconButton>
            </div>
            <DialogContent style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
              <div onClick={() => newService("service")} style={{ flex: 1, minWidth: "200px", border: "2px solid var(--svc-border)", borderRadius: "12px", padding: "1.5rem", cursor: "pointer", textAlign: "center", transition: "0.2s" }} onMouseOver={(e) => e.currentTarget.style.borderColor = "var(--svc-brand)"} onMouseOut={(e) => e.currentTarget.style.borderColor = "var(--svc-border)"}>
                <IoIosAddCircleOutline size={40} color="var(--svc-brand)" />
                <h4 style={{ margin: "10px 0 5px", fontWeight: 700 }}>Bookable Service</h4>
                <p style={{ fontSize: "0.85rem", color: "var(--svc-text-muted)", margin: 0 }}>Consultations, coaching, or group sessions.</p>
              </div>
              <div onClick={() => newService("resource")} style={{ flex: 1, minWidth: "200px", border: "2px solid var(--svc-border)", borderRadius: "12px", padding: "1.5rem", cursor: "pointer", textAlign: "center", transition: "0.2s" }} onMouseOver={(e) => e.currentTarget.style.borderColor = "var(--svc-brand)"} onMouseOut={(e) => e.currentTarget.style.borderColor = "var(--svc-border)"}>
                <FiDownload size={40} color="var(--svc-brand)" />
                <h4 style={{ margin: "10px 0 5px", fontWeight: 700 }}>Digital Resource</h4>
                <p style={{ fontSize: "0.85rem", color: "var(--svc-text-muted)", margin: 0 }}>One PDF, Excel, Word, or ODT file.</p>
              </div>
            </DialogContent>
          </Dialog>

          {state.shareCalendar && (
            <Dialog
              open={state.shareCalendar}
              onClose={() => calendarShare(false, null)}
              maxWidth="sm"
              fullWidth
              PaperProps={{ style: { maxWidth: "500px", borderRadius: "12px", maxHeight: "85vh", overflowY: "auto" } }}
            >
               <div style={{ padding: "1.25rem 1.5rem", display: "flex", justifyContent: "space-between" }}>
                  <h4 style={{ margin: 0, fontWeight: 700 }}>Share link</h4>
                  <AiOutlineCloseCircle size={22} style={{ cursor: "pointer" }} onClick={() => calendarShare(false, null)} />
               </div>
               <DialogContent dividers>
                  <div style={{ marginBottom: "1rem" }}>
                    <input readOnly value={`${BASE_URL}yuukke-service/${userSlots?.preference.slug}`} style={{ width: "100%", padding: "8px", border: "1px solid var(--border)", borderRadius: "4px" }} />
                  </div>
                  <SocialShare url={`${BASE_URL}yuukke-service/${userSlots?.preference.slug}`} title="Check my schedule" />
               </DialogContent>
            </Dialog>
          )}
          
          {showApprovalModal && <ApprovalPendingModal onClose={() => setShowApprovalModal(false)} />}
        </section>

        <ServiceProfileWizardCard
          visible={showAiAssistant} onClose={handleAssistantClose} serviceName={state.title}
          question={assistantQuestion} step={assistantQuestionsAsked} totalSteps={5}
          loading={assistantLoading} input={assistantInput} setInput={setAssistantInput}
          onNext={handleAssistantNext} isSummary={assistantIsSummary} summaryText={assistantSummaryText}
        />
        <AdvertiseServiceModal open={shareModalOpen} service={selectedService} onClose={() => setShareModalOpen(false)} slug={`${BASE_URL}yuukke-service/${userSlots?.preference?.slug}?serviceId=${selectedService?.serviceId}`} />
      </main>
    </BlockUi>
  );
};

export default withRouter(withTranslation()(Services));